module.exports = __webpack_public_path__ + "static/img/transys.7f89816.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/transys.jpg
// module id = ogdy
// module chunks = 0